import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import ScrollToTop from "../Mobile/Components/ScrollToTop";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ECECEC",
  },
  pageFullHeight: {
    position: "fixed",
    width: "100%",
    height: "100vh",
    maxHeight: "-webkit-fill-available",
  },
  pageWrapper: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  headerContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    "& h1": {
      textAlign: "center",
      fontWeight: 300,
      color: theme.palette.primary.dark,
      fontSize: "30px",
    },
  },
}));

const MobilePageMemo = React.memo(
  ({ children, fullHeight, scrollToTop = true }) => {
    const classes = useStyles();

    return (
      <>
        {scrollToTop && <ScrollToTop />}
        <div
          className={`${classes.pageContainer} ${
            fullHeight ? classes.pageFullHeight : ""
          }`}
        >
          <div className={classes.pageWrapper}>{children}</div>
        </div>
      </>
    );
  },
);

const MobilePage = (props) => {
  return <MobilePageMemo {...props} />;
};

MobilePage.defaultProps = {};

MobilePage.propTypes = {
  children: PropTypes.node.isRequired,
  requireUser: PropTypes.bool,
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const PageHeader = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.headerContainer}>
      <Typography variant="h1" color="primary">
        {children}
      </Typography>
    </div>
  );
};

const PageContent = ({ children }) => {
  return (
    <div>
      <Typography variant="body1">{children}</Typography>
    </div>
  );
};

export default MobilePage;

export { PageContainer, PageHeader, PageContent };
